import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { useIntl } from "react-intl";
import Button, {
  COLOR,
  VARIANT,
  SIZE,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { th } from "date-fns/locale";
import { StyledStep1ListItem } from "./TelegramSetting.styles";
import { useTheme } from "@mui/styles";
import useNavigateEntity from "hooks/useNavigateEntity";
import { InputField } from "@metacrm/metacrm-material-ui/dist/InputField";
import { BasicDialog } from "@metacrm/metacrm-material-ui/dist/Dialog";
import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useOutletContext, useSearchParams } from "react-router-dom";

const TelegramAnalyticsSettingStep2 = ({ onPrevStep, onNextStep }) => {
  const [entityName, isCustomDomain] = useOutletContext();
  const dispatchSnackbar = useDispatchSnackbar();

  const [apiToken, setApiToken] = useState("");
  const { navigateEntity } = useNavigateEntity();
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [failDialogShow, setFailDialogShow] = useState(false);
  const [isLOading, setIsLoading] = useState(false);

  return (
    <Box padding="0 30px" className="fade-up-more">
      <Box component={Grid} container spacing={5} alignItems="center">
        <Box component={Grid} item xs={12} sm={6}>
          <Box>
            <Box>
              <Box
                fontSize={"24px"}
                fontWeight={"700"}
                color={(theme) => theme.customColors.grey[700]}
                mb="32px"
              >
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step3.title",
                })}
              </Box>

              <Box
                sx={{
                  fontWeight: "400",
                  color: theme.customColors.grey[600],
                  lineHeight: "24px",
                }}
              >
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step3.description",
                })}
              </Box>
            </Box>
            <Box mt="48px">
              <Button
                variant={VARIANT.OUTLINED}
                sx={{ width: "120px", marginRight: "8px" }}
                onClick={onPrevStep}
              >
                {formatMessage({ id: "global.btn.back" })}
              </Button>
              <Button sx={{ width: "120px" }} onClick={onNextStep}>
                {formatMessage({ id: "global.btn.next" })}
              </Button>
            </Box>
          </Box>
        </Box>
        <Box component={Grid} item xs={12} sm={6}>
          <Box sx={{ backgroundColor: "#FAFAFD", padding: "17px 13px" }}>
            <Box
              sx={{
                fontWeight: "700",
                color: theme.customColors.grey[700],
                marginBottom: "32px",
              }}
            >
              <Box
                sx={{
                  color: theme.customColors.purple[500],
                  display: "inline-block",
                }}
              >
                img 03 .
              </Box>
              {formatMessage({
                id: "telegramAnalyticsBot.integrationWizard.step3.imgTitle",
              })}
            </Box>
            <Box
              sx={{ margin: "0 auto", display: "block" }}
              component={"img"}
              src={require("assets/img/tg-analytics-setting-step3.png")}
              width={"600px"}
            ></Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TelegramAnalyticsSettingStep2;
